<template>
  <div>
    <v-col class="px-0" v-if="wallets.length > 0">
      <v-row>
        <v-col cols="12" sm="6">
          <v-select
              v-model="filter.period"
              :items="periods"
              label="Período"
              item-text="value"
              return-object
              @change="search(filter)"
              outlined
              dense
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" v-show="advancedWalletOptions === 'true' && showWallets === 'true'">
          <v-select
              v-model="filter.wallet"
              :items="wallets"
              item-text="name"
              label="Carteira"
              required
              return-object
              @change="search(filter)"
              outlined
              dense
          ></v-select>
        </v-col>
      </v-row>

      <v-row class="mb-4">
        <v-col cols="12" class="d-flex justify-end flex-wrap export-buttons">
          <v-btn
              color="primary"
              class="ma-1"
              :loading="pdfLoading"
              :disabled="emailLoading || loading || rows.length === 0"
              @click="downloadPdf"
              elevation="2"
          >
            <v-icon left small>mdi-file-pdf-box</v-icon>
            <span class="d-none d-sm-inline">Baixar PDF</span>
            <span class="d-inline d-sm-none">PDF</span>
          </v-btn>

          <v-btn
              color="secondary"
              class="ma-1"
              :loading="emailLoading"
              :disabled="pdfLoading || loading || rows.length === 0"
              @click="sendPdfEmail"
              elevation="2"
          >
            <v-icon left small>mdi-email</v-icon>
            <span class="d-none d-sm-inline">Enviar por Email</span>
            <span class="d-inline d-sm-none">Email</span>
          </v-btn>
        </v-col>
      </v-row>

      <v-layout v-resize="onResize">
        <v-col class="px-0">
          <v-data-table
              :hide-default-header="isMobile"
              :headers="headers"
              :items="rows"
              :loading="loading"
              :items-per-page="50"
              locale="pt-BR"
              :hide-default-footer="rows.length === 0 || rows.length < 10"
              class="elevation-1"
          >
            <template v-slot:item.type="{ item }">
              <template v-if="item.type === 17">
                Regularização do veículo {{ item.plate }}
              </template>
              <template v-else-if="item.type === 6">
                Estacionamento {{ item.plate }}
              </template>
              <template v-else>
                {{ item.type_name }}
              </template>
            </template>
            <template v-slot:item.created_at="{ item }">
              {{ item.created_at | timeStampToHuman }}
            </template>
            <template v-slot:item.amount="{ item }">
              R$ {{ item.amount | integerToMoney | integerToMoney2 }}
            </template>
            <template slot="no-data">
              Nenhum dado encontrado.
            </template>
            <template slot="loading">
              Carregando
            </template>
          </v-data-table>
        </v-col>
      </v-layout>
    </v-col>

    <div class="message-data text-center" v-show="wallets.length === 0 && loading === false">
      <i class="far fa-bell"></i>
      <span>Você não possui nenhuma carteira cadastrada.</span>
    </div>

    <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
        bottom
        right
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import '../filters';
import axios from 'axios';
import moment from 'moment';
import PdfExportService from '../services/PdfExportService';

export default {
  name: "WalletsHistory",
  data: function () {
    return {
      isMobile: false,
      filter: {
        wallet: {
          name: ''
        },
        period: null
      },
      periods: [
        {label: 0, value: 'Todo o período'},
        {label: 1, value: 'Hoje'},
        {label: 2, value: 'Os últimos 7 dias'},
        {label: 3, value: 'Esse mês'},
        {label: 4, value: 'Mês anterior'},
        {label: 5, value: 'Esse ano'}
      ],
      wallets: [],
      loading: false,
      pdfLoading: false,
      emailLoading: false,
      snackbar: {
        show: false,
        text: '',
        color: 'success',
        timeout: 4000
      },
      headers: [
        {text: 'Operação', sortable: false, filter: false, value: 'type'},
        {text: 'Data', sortable: false, filter: false, value: 'created_at'},
        {text: 'Forma de Pagamento', sortable: false, filter: false, value: 'payment_form_name'},
        {text: 'Valor', sortable: false, filter: false, value: 'amount'},
      ],
      rows: []
    };
  },
  mounted() {
    this.loadWallets();
  },
  methods: {
    showSnackbar(text, color = 'success') {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    onResize() {
      this.isMobile = window.innerWidth < 769;
    },
    loadWallets() {
      this.loading = true;

      axios.get('/api/users/driver/me/wallet').then(res => {
        this.wallets = res.data.data;
        this.filter.wallet = this.wallets[0];
        this.filter.period = this.periods[0];
        this.search(this.filter);
      }).catch(() => {
        this.showSnackbar('Erro ao carregar carteiras. Tente novamente.', 'error');
      }).finally(() => {
        this.loading = false;
      });
    },
    buildFilterParams(filter) {
      const params = {};

      if (filter.wallet.id) {
        params.wallet = filter.wallet.id;
      }

      switch (filter.period.label) {
        case 1:
          params.created_at_begin = moment().format('YYYY-MM-DD 00:00:00');
          params.created_at_end = moment().format('YYYY-MM-DD 23:59:59');
          break;
        case 2:
          params.created_at_begin = moment().subtract('7', 'days').format('YYYY-MM-DD 00:00:00');
          params.created_at_end = moment().format('YYYY-MM-DD 23:59:59');
          break;
        case 3:
          params.created_at_begin = moment().startOf('month').format('YYYY-MM-DD 00:00:00');
          params.created_at_end = moment().endOf('month').format('YYYY-MM-DD 23:59:59');
          break;
        case 4:
          params.created_at_begin = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD 00:00:00');
          params.created_at_end = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD 23:59:59');
          break;
        case 5:
          params.created_at_begin = moment().startOf('year').format('YYYY-MM-DD 00:00:00');
          params.created_at_end = moment().endOf('year').format('YYYY-MM-DD 23:59:59');
          break;
      }

      return params;
    },
    search(filter) {
      this.rows = [];
      const params = this.buildFilterParams(filter);

      if (!params.wallet) {
        return;
      }

      this.loading = true;

      axios.get('/api/users/driver/me/app/transaction', {params}).then(res => {
        this.rows = res.data.data;
      }).catch(() => {
        this.showSnackbar('Erro ao buscar histórico. Tente novamente.', 'error');
      }).finally(() => {
        this.loading = false;
      });
    },
    async downloadPdf() {
      const params = this.buildFilterParams(this.filter);

      if (!params.wallet) {
        this.showSnackbar('Selecione uma carteira válida.', 'warning');
        return;
      }

      this.pdfLoading = true;

      try {
        await PdfExportService.downloadPdf(
            '/api/users/driver/me/app/transaction/pdf',
            params
        );
        this.showSnackbar('PDF baixado com sucesso!');
      } catch (error) {
        this.showSnackbar(
            error.message || 'Ocorreu um problema ao gerar o PDF. Tente novamente mais tarde!',
            'error'
        );
      } finally {
        this.pdfLoading = false;
      }
    },
    async sendPdfEmail() {
      const params = this.buildFilterParams(this.filter);

      if (!params.wallet) {
        this.showSnackbar('Selecione uma carteira válida.', 'warning');
        return;
      }

      this.emailLoading = true;

      try {
        await PdfExportService.sendPdfEmail(
            '/api/users/driver/me/app/transaction/email',
            params
        );
        this.showSnackbar('O relatório em PDF foi enviado para o email cadastrado!');
      } catch (error) {
        this.showSnackbar(
            error.message || 'Ocorreu um erro ao enviar o email. Tente novamente mais tarde.',
            'error'
        );
      } finally {
        this.emailLoading = false;
      }
    }
  },
  computed: {
    advancedWalletOptions() {
      return process.env.VUE_APP_ADVANCED_WALLET_OPTIONS;
    },
    showWallets() {
      return process.env.VUE_APP_SHOW_WALLETS;
    }
  }
};
</script>

<style scoped>
th, td.v-data-table__mobile-row {
  padding: 0 !important;
}

.export-buttons {
  gap: 8px;
}

@media only screen and (max-width: 600px) {
  .export-buttons {
    justify-content: center !important;
  }
}
</style>
